var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.139 11.3084V1.12434C14.139 0.963649 14.0087 0.833374 13.848 0.833374H5.77133C5.53982 0.833374 5.31778 0.925354 5.15408 1.08906L2.75569 3.48745C2.59198 3.65116 2.5 3.87319 2.5 4.10471V15.0911C2.5 15.2518 2.63028 15.382 2.79097 15.382H10.0653",
    fill: "#1E3A8A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.139 11.3084V1.12434C14.139 0.963649 14.0087 0.833374 13.848 0.833374H5.77133C5.53982 0.833374 5.31778 0.925354 5.15408 1.08906L2.75569 3.48745C2.59198 3.65116 2.5 3.87319 2.5 4.10471V15.0911C2.5 15.2518 2.63028 15.382 2.79097 15.382H10.0653",
    stroke: "#1E3A8A",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 1.91926V3.5C5.5 3.73155 5.31228 3.91926 5.08074 3.91926H3.5",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.77409 5.48889H4.24561V13.0542L12.3928 11.5993V5.48889H11.5199",
    stroke: "white",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3933 10.1445H7.15576",
    stroke: "white",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.40948 10.1445H4.24561",
    stroke: "white",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.31934 10.1446V8.6897",
    stroke: "white",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.31934 6.94377V5.48889",
    stroke: "white",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.393 5.48904V3.16125L8.90137 3.78345V5.48904",
    stroke: "white",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8783 11.8904L16.4668 11.4789C16.2395 11.2517 15.871 11.2517 15.6438 11.4789L10.0659 17.0568C9.95401 17.1687 9.87466 17.3089 9.83626 17.4624L9 19.3572L10.8948 18.5209C11.0483 18.4826 11.1885 18.4032 11.3004 18.2913L16.8782 12.7134C17.1055 12.4862 17.1055 12.1177 16.8783 11.8904Z",
    fill: "#1E3A8A",
    stroke: "#1E3A8A",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2319 11.8904L16.4664 13.1249",
    stroke: "#1E3A8A",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3066 16.8163L11.5411 18.0508",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayout);
export default __webpack_public_path__ + "static/media/layout.e26ca36d4749c8f29d955bcdb2884ff6.svg";
export { ForwardRef as ReactComponent };